import React from 'react';
import { FiBarChart2 } from 'react-icons/fi';
import { DataRoomStats } from '../../types/dataRoom';

// Type cast icons for React 18 compatibility
const BarChartIcon = FiBarChart2 as React.FC<React.SVGProps<SVGSVGElement>>;

interface AnalyticsPanelProps {
  stats: DataRoomStats | null;
  isLoading?: boolean;
}

const AnalyticsPanel: React.FC<AnalyticsPanelProps> = ({ stats, isLoading = false }) => {
  return (
    <div className="su-dataroom-section">
      <div className="su-dataroom-section-header">
        <div className="su-dataroom-section-title">
          <BarChartIcon />
          <span>Analytics</span>
        </div>
      </div>
      <div className="su-dataroom-section-body">
        {isLoading ? (
          <div className="su-analytics-list">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="su-analytics-row">
                <div className="h-4 w-20 bg-gray-800 rounded animate-pulse" />
                <div className="h-5 w-8 bg-gray-800 rounded animate-pulse" />
              </div>
            ))}
          </div>
        ) : (
          <div className="su-analytics-list">
            <div className="su-analytics-row">
              <span className="su-analytics-label">Total Views</span>
              <span className="su-analytics-value">{stats?.total_views ?? 0}</span>
            </div>
            <div className="su-analytics-row">
              <span className="su-analytics-label">Unique Visitors</span>
              <span className="su-analytics-value">{stats?.unique_visitors ?? 0}</span>
            </div>
            <div className="su-analytics-row">
              <span className="su-analytics-label">Active Links</span>
              <span className="su-analytics-value">{stats?.active_links ?? 0}</span>
            </div>
            <div className="su-analytics-row">
              <span className="su-analytics-label">Documents</span>
              <span className="su-analytics-value">{stats?.total_documents ?? 0}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AnalyticsPanel;
